import React, { useState } from 'react';

const SERVICE_NAMES = {
  pastPrediction:     'Past Prediction',
  futureConsultation: 'Future Consultation',
  remedies:           'Remedies',
  palmistry:          'Palmistry Reading',
  astroVastu:         'Astro Vastu',
  numerology:         'Numerology',
  tarot:              'Tarot Reading',
  compatibility:      'Compatibility',
  horoscopePDF:       'Horoscope PDF',
  tenYearPDF:         '10 Year Life PDF',
};

const SessionNotes = ({ clientData, service, chatHistory, sessionTimer, aiData, activeSessionId, onEnd, notes: notesProp, onNotesChange }) => {
  const isControlled                        = notesProp !== undefined;
  const [localNotes,     setLocalNotes]     = useState('');
  const notes    = isControlled ? notesProp    : localNotes;
  const setNotes = isControlled ? onNotesChange : setLocalNotes;
  const [confirmations,  setConfirmations]  = useState([]);
  const [newConf,        setNewConf]        = useState('');
  const [showConfInput,  setShowConfInput]  = useState(false);
  const [learnings,      setLearnings]      = useState('');
  const [saved,          setSaved]          = useState(false);

  const addConfirmation = () => {
    if (!newConf.trim()) return;
    const ts = new Date().toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });
    setConfirmations(c => [...c, { text: newConf.trim(), ts }]);
    setNewConf('');
    setShowConfInput(false);
  };

  const saveNotes = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  const downloadSessionData = async () => {
    if (!activeSessionId) return;
    const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    try {
      const r = await fetch(`${API_BASE}/api/training/session/${activeSessionId}`);
      if (!r.ok) return;
      const blob = await r.blob();
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement('a');
      a.href     = url;
      a.download = `vtd-training-${clientData.name.replace(/\s+/g,'-')}-${new Date().toLocaleDateString('en-IN').replace(/\//g,'-')}.json`;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (e) { console.error('Download data failed:', e); }
  };

  const downloadReport = () => {
    const sid  = `VTD-${Date.now().toString(36).toUpperCase()}`;
    const date = new Date().toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });

    const predictions = chatHistory
      .filter(m => m.type === 'ai')
      .map((m, idx) => {
        const sec = m.section || 'General';
        const txt = (m.english || m.telugu || '').slice(0, 800);
        return `[${idx + 1}] ${sec.toUpperCase()}\n${txt}`;
      })
      .join('\n\n---\n\n');

    const lines = [
      'VTD ASTROLOGY — SESSION REPORT',
      '================================',
      `Date       : ${date}`,
      `Session ID : ${sid}`,
      `Astrologer : VTD Team`,
      `Service    : ${SERVICE_NAMES[service] || service}`,
      `Language   : ${clientData.language}`,
      `Duration   : ${sessionTimer}`,
      '',
      'CLIENT DETAILS',
      '--------------',
      `Name   : ${clientData.name}`,
      `DOB    : ${clientData.dob}`,
      `TOB    : ${clientData.tob || '—'}`,
      `Place  : ${clientData.pob}`,
      `Gender : ${clientData.gender}`,
      '',
      'BIRTH CHART SUMMARY',
      '-------------------',
      `Lagna       : ${aiData?.chartData?.ascendant || '—'}`,
      `Maha Dasha  : ${aiData?.dashaData?.current?.maha_dasha?.planet || '—'}`,
      `Antar Dasha : ${aiData?.dashaData?.current?.antar_dasha?.planet || '—'}`,
      '',
      'PREDICTIONS GIVEN',
      '-----------------',
      predictions || '— None recorded —',
      '',
      'ASTROLOGER NOTES',
      '----------------',
      notes || '— None —',
      '',
      'CLIENT CONFIRMATIONS',
      '--------------------',
      confirmations.length
        ? confirmations.map(c => `[${c.ts}]  ${c.text}`).join('\n')
        : '— None —',
      '',
      'SESSION STATISTICS',
      '------------------',
      `Sections covered    : ${chatHistory.filter(m => m.type === 'ai').length}`,
      `Client confirmations: ${confirmations.length}`,
      '',
      'LEARNINGS FROM THIS SESSION',
      '---------------------------',
      learnings || '— None —',
      '',
      '================================',
      'CONFIDENTIAL — Internal VTD use only.',
      '© VTD Astrology · vtdastrology.com',
      '================================',
    ].join('\n');

    const blob = new Blob([lines], { type: 'text/plain;charset=utf-8' });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href     = url;
    a.download = `VTD-${clientData.name.replace(/\s+/g, '-')}-${date.replace(/\s+/g, '-')}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <aside className="ap-col ap-col--right sn">

      {/* Timer + client strip */}
      <div className="sn-header">
        <div className="sn-timer">
          <span className="sn-timer__label">Duration</span>
          <span className="sn-timer__value">{sessionTimer}</span>
        </div>
        <div className="sn-client">
          <div className="sn-client__name">{clientData.name}</div>
          <div className="sn-client__meta">
            {SERVICE_NAMES[service] || service} · {clientData.language}
          </div>
        </div>
      </div>

      {/* Astrologer Notes */}
      <div className="sn-block">
        <div className="sn-block__title">Astrologer Notes</div>
        <textarea
          className="sn-textarea"
          rows={6}
          value={notes}
          onChange={e => setNotes(e.target.value)}
          placeholder="Type notes during session..."
        />
      </div>

      {/* Client Confirmations */}
      <div className="sn-block">
        <div className="sn-block__header">
          <div className="sn-block__title">Client Confirmations</div>
          <button className="sn-add-btn" onClick={() => setShowConfInput(v => !v)}>
            {showConfInput ? '✕' : '+ Add'}
          </button>
        </div>
        {showConfInput && (
          <div className="sn-conf-row">
            <input
              className="sn-conf-input"
              type="text"
              placeholder="What client confirmed..."
              value={newConf}
              onChange={e => setNewConf(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && addConfirmation()}
              autoFocus
            />
            <button className="sn-conf-ok" onClick={addConfirmation}>✓</button>
          </div>
        )}
        <div className="sn-conf-list">
          {confirmations.length === 0
            ? <p className="sn-empty">No confirmations yet</p>
            : confirmations.map((c, i) => (
                <div key={i} className="sn-conf-item">
                  <span className="sn-conf-ts">{c.ts}</span>
                  <span className="sn-conf-text">{c.text}</span>
                </div>
              ))
          }
        </div>
      </div>

      {/* Session Learnings */}
      <div className="sn-block">
        <div className="sn-block__title">Session Learnings</div>
        <textarea
          className="sn-textarea"
          rows={4}
          value={learnings}
          onChange={e => setLearnings(e.target.value)}
          placeholder="Accuracy, patterns observed, new insights..."
        />
      </div>

      <div className="ap-col__spacer" />

      {/* Actions */}
      <div className="sn-actions">
        <button
          className={`sn-btn sn-btn--save${saved ? ' sn-btn--saved' : ''}`}
          onClick={saveNotes}
        >
          {saved ? '✓ Saved' : 'Save Notes'}
        </button>
        <button className="sn-btn sn-btn--report" onClick={downloadReport}>
          Download Report
        </button>
        {activeSessionId && (
          <button className="sn-btn sn-btn--data" onClick={downloadSessionData}>
            📥 Download Data
          </button>
        )}
        <button className="sn-btn sn-btn--end" onClick={onEnd}>
          End Session
        </button>
      </div>

    </aside>
  );
};

export default SessionNotes;
